import React from 'react';
import { Navigate, NavLink, Route, Routes } from 'react-router-dom';
import MembershipSidebar from '../../components/MasterAdmin/membership/MembershipSidebar';
import MembershipDashboardPanel from '../../components/MasterAdmin/membership/MembershipDashboardPanel';
import MembershipPlansPanel from '../../components/MasterAdmin/membership/MembershipPlansPanel';
import MembershipMembersPanel from '../../components/MasterAdmin/membership/MembershipMembersPanel';
import MembershipTransfersPanel from '../../components/MasterAdmin/membership/MembershipTransfersPanel';
import MembershipReportsPanel from '../../components/MasterAdmin/membership/MembershipReportsPanel';
import MembershipToolsPanel from '../../components/MasterAdmin/membership/MembershipToolsPanel';
import MembershipSettingsPanel from '../../components/MasterAdmin/membership/MembershipSettingsPanel';
import {
  MEMBERSHIP_BASE_PATH,
  MEMBERSHIP_TABS,
  msMobileTabs,
  msPageWrap,
  msShell,
} from '../../components/MasterAdmin/membership/membershipUi';

const MembershipMobileTabs: React.FC = () => (
  <div className={`${msMobileTabs} md:hidden`}>
    {MEMBERSHIP_TABS.map((tab) => (
      <NavLink
        key={tab.path}
        to={tab.path}
        end={tab.id === 'dashboard'}
        className={({ isActive }) =>
          `shrink-0 px-3 py-2.5 text-center text-xs font-medium whitespace-nowrap ${
            isActive
              ? 'border-b-2 border-emerald-600 text-emerald-600'
              : 'text-gray-600 dark:text-gray-300'
          }`
        }
      >
        {tab.label}
      </NavLink>
    ))}
  </div>
);

const MembershipManagementPage: React.FC = () => {
  return (
    <div className={msPageWrap}>
      <MembershipMobileTabs />
      <div className={msShell}>
        <MembershipSidebar />
        <main className="flex min-w-0 flex-1 flex-col overflow-hidden">
          <Routes>
            <Route index element={<MembershipDashboardPanel />} />
            <Route path="plans" element={<MembershipPlansPanel />} />
            <Route path="members" element={<MembershipMembersPanel />} />
            <Route path="transfers" element={<MembershipTransfersPanel />} />
            <Route path="reports" element={<MembershipReportsPanel />} />
            <Route path="settings" element={<MembershipSettingsPanel />} />
            <Route path="tools" element={<MembershipToolsPanel />} />
            <Route path="*" element={<Navigate to={MEMBERSHIP_BASE_PATH} replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default MembershipManagementPage;
